export default "<p>......</p>\n"